import React from "react";
import { Trophy } from "@phosphor-icons/react";

/**
 * SteadyHandBadge
 * -----------------------------------------------------------
 * Positive-recognition trophy shown next to a driver's name once
 * their safety scorecard hits 90%+ compliance over 10+ pre-warning
 * events (see backend `core/safety.py`).
 *
 * Renders nothing when `steady` is falsy so callers can drop this
 * inline without needing a null-check.
 *
 * Sizes: "sm" (inline with name), "md" (profile hero), "pill" (chip).
 */
export default function SteadyHandBadge({ steady, size = "sm", label = false }) {
  if (!steady) return null;

  if (size === "pill") {
    return (
      <span
        data-testid="steady-hand-badge"
        title="Steady Hand — 90%+ safety compliance"
        className="inline-flex items-center gap-1 bg-primary text-foreground border-2 border-foreground px-2 py-0.5 font-mono text-[10px] uppercase tracking-[0.15em]"
      >
        <Trophy size={12} weight="fill" />
        Steady Hand
      </span>
    );
  }

  const iconSize = size === "md" ? 18 : 12;
  return (
    <span
      data-testid="steady-hand-badge"
      title="Steady Hand — 90%+ safety compliance"
      className="inline-flex items-center gap-0.5 text-primary"
      aria-label="Steady Hand safety trophy"
    >
      <Trophy size={iconSize} weight="fill" />
      {label && (
        <span className="font-mono text-[9px] uppercase tracking-wider">
          Steady
        </span>
      )}
    </span>
  );
}
